export const Passport = () => {
  return (
    <svg viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="11"
        height="15"
        rx="0.5"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <circle cx="6" cy="6" r="3.5" stroke="currentColor" />
      <line
        x1="3.5"
        y1="13.5"
        x2="8.5"
        y2="13.5"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <line
        x1="3.5"
        y1="11.5"
        x2="8.5"
        y2="11.5"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M6.5 2.5C6.5 2.5 7.5 4 7.5 6C7.5 8 6.5 9.5 6.5 9.5M5.5 2.5C5.5 2.5 4.5 4 4.5 6C4.5 8 5.5 9.5 5.5 9.5"
        stroke="currentColor"
      />
      <path
        d="M2.5 5.5C2.5 5.5 4 6.5 6 6.5C8 6.5 9.5 5.5 9.5 5.5"
        stroke="currentColor"
      />
    </svg>
  )
}
